import { Navigate } from 'react-router-dom'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import useEmployeePolicyData from 'modules/payroll_bundle/hooks/useEmployeePolicyData'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'

const RedirectCyclesPage = () => {
  const { currentEmployeePolicyId, policies, data } = useEmployeePolicyData()

  const {
    supplementsSeeEverybody,
    supplementsSeeReportees,
    supplementsSeeTeam,
    managePayrollIncidences,
  } = data?.payroll._policies ?? {}

  const canSeeOverview =
    supplementsSeeTeam?.can ||
    supplementsSeeReportees?.can ||
    supplementsSeeEverybody?.can ||
    managePayrollIncidences?.can

  const { navigation } = useNavigation()

  // Does this behavior make sense? Should we not leverage the current URL?
  const { policyId: currentPolicyId } = usePolicyPeriods()

  const redirectPath = useUnsafeMemo(() => {
    if (!data) {
      return null
    }

    const basePolicyPath = navigation.payrollBundle.policy

    // Can't see the policy overview page so will go to the policy
    if (!canSeeOverview) {
      return currentEmployeePolicyId
        ? basePolicyPath.dashboard.fullPath({
            policyId: currentEmployeePolicyId,
          })
        : navigation.payrollBundle.noPolicies.fullPath()
    }

    if (!policies?.length) {
      return navigation.payrollBundle.setup.fullPath()
    }

    if (currentPolicyId) {
      return basePolicyPath.dashboard.fullPath({ policyId: currentPolicyId })
    }

    const policy = policies?.at(0)
    if (policy) {
      return basePolicyPath.dashboard.fullPath({ policyId: policy.id })
    }
  }, [canSeeOverview, currentEmployeePolicyId, currentPolicyId, data, navigation, policies])

  if (!redirectPath) return <></>

  return <Navigate to={redirectPath}></Navigate>
}

export default RedirectCyclesPage
